export default "__VITE_ASSET__$rj_35VL__"